// React
import React, { useEffect, useState } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Telegram UI
import { AppRoot, Cell, Multiselectable, Section } from '@telegram-apps/telegram-ui';

// Icons
import { ReactComponent as ForceIcon } from "../assets/force.svg";
import { ReactComponent as MediaIcon } from "../assets/media.svg";
import { ReactComponent as OriginalIcon } from "../assets/original.svg";
import { ReactComponent as SourceIcon } from "../assets/source.svg";
import { ReactComponent as LinkOriginalIcon } from "../assets/link_original.svg";

const tg = window.Telegram.WebApp;

const OtherPage = ({ activePanel, setActivePanel, userInfo, FaTelegram, baseTheme, avatarSrc, isMobile, setGptLink, setGptMedia, setGptText, selectedGroup, activeView, setActiveView, premodePosts, stream, setStream }) => {
    const [force, setForce] = useState(stream.force);
    const [media, setMedia] = useState(stream.media);
    const [original, setOriginal] = useState(stream.original);
    const [source, setSource] = useState(stream.source);
    const [linkOriginal, setLinkOriginal] = useState(stream.link_original)

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('channel');
        };

        if (activePanel === 'other') {
            tg.BackButton.show();
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);


    useEffect(() => {
        const saveOther = async () => {
            const url = 'https://api.gmpapp.ru/save_other';

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ group_id: selectedGroup.id, stream_id: stream.id, force: force, media: media, original: original, source: source, link_original: linkOriginal }),
                });

                if (!response.ok) {
                    // Здесь можно обрабатывать неуспешные коды ответов
                    console.error('Error:', response.status, response.statusText);
                } else {
                    // Если ответ успешен, можно сделать что-то с данными
                    const data = await response.json();
                    console.log('Success:', data);
                    
                    // Оптимистичное обновление: мутируем сам объект stream
                    stream.force = force;
                    stream.media = media;
                    stream.original = original;
                    stream.source = source;
                    stream.link_original = linkOriginal;
                }
            } catch (error) {
                console.error('Error streams sending', error);
            }
        };

        saveOther();
    }, [force, media, original, source, linkOriginal]);

    const handleForceChange = (event) => {
        setForce(event.target.checked);
    };

    const handleMediaChange = (event) => {
        setMedia(event.target.checked);
    };

    const handleOriginalChange = (event) => {
        setOriginal(event.target.checked);
    };

    const handleLinkOriginalChange = (event) => {
        setLinkOriginal(event.target.checked);
    };

    const handleSourceChange = (event) => {
        setSource(event.target.checked);
    };

    return (
        <div className="wrapperUI">
            <AppRoot platform='ios'>
                <Section className='sectionChannelOther' header="Дополнительные параметры">
                    <Cell Component="label" before={<ForceIcon className="SettingsItemIcon" />} onChange={handleForceChange} after={<Multiselectable name="checkbox" defaultChecked={force} />} multiline subtitle="Cервис будет брать последнюю статью из источников, в случае если по найденным ключевым словам ничего не найдено или все новости по ключевым словам уже были опубликованы">Принудительный постинг</Cell>
                    <Cell Component="label" before={<MediaIcon className="SettingsItemIcon" />} onChange={handleMediaChange} after={<Multiselectable name="checkbox" defaultChecked={media} />} multiline subtitle="Пост не будет содержать в себе картинку или видео, даже если они есть в найденной новости">Отключить медиа</Cell>
                    <Cell Component="label" before={<OriginalIcon className="SettingsItemIcon" />} onChange={handleSourceChange} after={<Multiselectable name="checkbox" defaultChecked={source} />} multiline subtitle="Текст из найденной новости будет перенесён без изменений. Работает только с Telegram-каналами и пабликами/группами VK в качестве источников">Перенос исходного текста</Cell>
                    <Cell Component="label" before={<SourceIcon className="SettingsItemIcon" />} onChange={handleOriginalChange} after={<Multiselectable name="checkbox" defaultChecked={original} />} multiline subtitle="В посте будет указан URL исходной статьи">Добавить ссылку в пост</Cell>
                    <Cell Component="label" before={<LinkOriginalIcon className="SettingsItemIcon" />} onChange={handleLinkOriginalChange} after={<Multiselectable name="checkbox" defaultChecked={linkOriginal} />} multiline subtitle="В посте будет указан сайт исходной статьи">Добавить источник в пост</Cell>
                </Section>
            </AppRoot>
        </div>
    );
};

export default OtherPage;